import axios from 'axios';
import defs from '@ey/osg-style/src/images/common/svgdefs.svg';
import localDefs from '../../../assets/icons/svgdefs.svg';
import DOMPurify from 'dompurify';
const sanitize = DOMPurify.sanitize;

function loadSVG(defs) {
	axios
		.get(defs, {
			responseType: 'text'
		})
		.then(({data}) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(sanitize(data), 'application/xml');
			document.body.appendChild(doc.documentElement);
		});
}

console.log('Loading SVG');
loadSVG(defs);
loadSVG(localDefs);
